export default class Button {
  constructor(el) {
    this.el = el
    this.svg = el.querySelector('.btn--picto svg')
    this.flair = null
    this.init()
  }

  init() {
    if (this.svg) {
      this.el.addEventListener('mouseenter', () => this.onEnter())
      this.el.addEventListener('mouseleave', () => this.onLeave())
      this.svg.addEventListener('animationend', () => this.onAnimEnd())
    }

    this.initFlair()
  }

  initFlair() {
    this.flair = document.createElement('div')
    this.flair.className = 'btn__flair'
    this.el.appendChild(this.flair)

    this.el.addEventListener('mouseenter', (e) => this.moveFlair(e))
    this.el.addEventListener('mousemove', (e) => this.moveFlair(e))
  }

  moveFlair(e) {
    const { left, top, width, height } = this.el.getBoundingClientRect()
    const x = ((e.clientX - left) / width) * 100
    const y = ((e.clientY - top) / height) * 100
    this.flair.style.transform = `translate(${x}%, ${y}%)`
  }

  onEnter() {
    this.svg.classList.remove('is-settled')
    this.svg.classList.add('is-entering')
  }

  onLeave() {
    this.svg.classList.remove('is-entering', 'is-settled')
  }

  onAnimEnd() {
    this.svg.classList.remove('is-entering')
    this.svg.classList.add('is-settled')
  }
}
